import { render } from "./RealtimeHrView.vue?vue&type=template&id=90d787e8&scoped=true"
import script from "./RealtimeHrView.vue?vue&type=script&lang=js"
export * from "./RealtimeHrView.vue?vue&type=script&lang=js"

import "./RealtimeHrView.vue?vue&type=style&index=0&id=90d787e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d787e8"]])

export default __exports__